<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="Default Currency Settings"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="false"
      />
    </b-col>
    <b-col>
      <b-card
        ><!--
         v-if="
          Object.keys((tenantPreferences && tenantPreferences.currency) || '')
            .length == 0
        "
      -->
        <b-row>
          <b-col md="6">
            <eb-select
              type="select"
              :options="resourceData"
              label="resourceCode"
              id="ResourceCode"
              placeholder="Currency Name"
              class="mt-0 currencyNameDropdown mb-0"
              v-model="selectedCode"
              :selected="selectedCode"
              @input="onSelectCode(selectedCode)"
            ></eb-select>
          </b-col>
          <b-col md="6">
            <b-form-input
              inputType="text"
              placeholder="Currency Code"
              class="mt-0"
              readonly
              v-model="selectedName"
            />
          </b-col>
          <b-col md="6">
            <b-form-input
              inputType="text"
              placeholder="Currency Symbol"
              class="mt-4"
              v-model="currencySymbol"
            />
          </b-col>
          <b-col md="6">
            <b-form-input
              inputType="text"
              placeholder="Resource ID"
              class="mt-4"
              readonly
              v-model="selectedId"
            />
          </b-col>
        </b-row>
      </b-card>
      <b-col md="12" v-if="true">
        <!--
         v-if="
          Object.keys((tenantPreferences && tenantPreferences.currency) || '')
            .length == 0
        "
      -->
        <div class="text-center language-button">
          <button
            variant="danger"
            type="button"
            class="text-uppercase btn btn-lg btn-danger"
            @click="backToProfile"
          >
            Cancel
          </button>
          <button
            variant="primary"
            type="button"
            class="text-uppercase btn btn-lg btn-primary"
            @click="currencySettingSave"
          >
            Save
          </button>
        </div>
      </b-col>
      <b-card v-if="false"
        ><!--
         v-if="
          Object.keys((tenantPreferences && tenantPreferences.currency) || '')
            .length != 0
        "
      -->
        <b-row>
          <b-col md="6">
            <eb-select
              type="select"
              :options="resourceData"
              label="resourceCode"
              id="ResourceCode"
              placeholder="Currency Code"
              class="mt-0 currencyNameDropdown mb-0"
              v-model="tenantPreferences.currency.code"
              :selected="tenantPreferences.currency.code"
              @input="onSelectCode(tenantPreferences.currency.code)"
              :disabled="true"
            ></eb-select>
          </b-col>
          <b-col md="6">
            <b-form-input
              inputType="text"
              placeholder="Currency Name"
              class="mt-0"
              readonly
              v-model="tenantPreferences.currency.name"
            />
          </b-col>
          <b-col md="6">
            <b-form-input
              inputType="text"
              placeholder="Currency Symbol"
              class="mt-0"
              v-model="tenantPreferences.currency.symbol"
              disabled
            />
          </b-col>
          <b-col md="6">
            <b-form-input
              inputType="text"
              placeholder="Resource ID"
              class="mt-0"
              readonly
              v-model="tenantPreferences.currency._id"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import profile from "@/components/profile/profileCategory";
import { mapGetters, mapActions } from "vuex";
import { resourcesCurrency } from "@/utils/resourcesCurrency";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  components: {
    profile,
    ebSelect,
    ComponentHeader,
  },
  data() {
    return {
      selectedCode: "",
      selectedName: "",
      selectedId: "",
      currencySymbol: "",
      resourceID: "",
    };
  },
  computed: {
    ...mapGetters({
      tenantPreferences: "tenant/GetTenantPreferences",
    }),
    resourceData() {
      return resourcesCurrency;
    },
  },
  methods: {
    async currencySettingSave() {
      let payload = {
        id: this.$currentUserData._id,
        binding: {
          currency: {
            _id: this.selectedId,
            name: this.selectedName,
            code: this.selectedCode,
            symbol: this.currencySymbol,
          },
        },
      };
      await this.$store
        .dispatch("tenant/updatePreferencesTenant", payload)
        .then(() => {
          (this.selectedId = ""),
            (this.selectedName = ""),
            (this.selectedCode = ""),
            (this.currencySymbol = ""),
            this.$swal({
              title: "Success",
              text: "Currency Settings Updated Successfully!!",
              type: "success",
            });
          this.getTenantPref();
        })
        .catch((err) => {
          this.$swal({
            title: "Opps!!!!!",
            text: "Unable to Update Currency Settings",
            type: "error",
          });
        });
    },
    async getTenantPref() {
      await this.$store.dispatch(
        "tenant/getTenantPreferences",
        this.$currentUserData._id
      );
      this.selectedCode = this.tenantPreferences.currency.code;
      this.selectedName = this.tenantPreferences.currency.name;
      this.selectedId = this.tenantPreferences.currency._id;
      this.currencySymbol = this.tenantPreferences.currency.symbol;
    },
    onSelectCode(e) {
      this.selectedCode = e.resourceCode;
      this.selectedName = e.resourceName;
      this.selectedId = e.resourceId;
      this.currencySymbol = e.resourceSymbol;
    },
    backToProfile() {
      this.$router.push("/profile/profile-info");
    },
  },
  mounted() {
    this.selectedCode = this.tenantPreferences.currency.code;
    this.selectedName = this.tenantPreferences.currency.name;
    this.selectedId = this.tenantPreferences.currency._id;
    this.currencySymbol = this.tenantPreferences.currency.symbol;
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style scoped>
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
}
@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
